import { porticoApi } from 'store/porticoApi'

import { TVenues } from 'types/venues'

type TVenuesResponse = {
  allVanues: boolean
  venues: TVenues[]
}

const venues = porticoApi.injectEndpoints({
  endpoints: (builder) => ({
    getVenues: builder.query<TVenues[], void>({
      query: () => `devices/venues`,
      transformResponse: (response: TVenuesResponse) => {
        return response?.venues
      },
      providesTags: (result) => {
        return result
          ? [...result.map(({ venueUuid }) => ({ type: 'Venues' as const, id: venueUuid }))]
          : ['Venues']
      },
    }),
  }),
})

export const { useGetVenuesQuery } = venues
